import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';
import { TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { characterCounter } from '~src/commonInfra/utils/CharacterCounter';

import { Messages } from '../../../codegen/Localize';
import { ReactActionDialogBodyProps } from '../../../commonInfra/dialogs/ReactActionDialog';
import {
    dialogBodyStyles,
    dialogElementStyles,
    groupSetNameFieldStyles,
    labelStyles,
    textFieldStyles} from '../../groupsets/components/styles/CreateGroupSetDialogStyles';


const NAME_GROUP_TEXT_FIELD_TEST_ID = 'confirm-action-dialog-input-text-box';

export const CHARACTER_LIMIT = 255;
const ZERO_WIDTH_SPACE = '\u200B';

export type CreateGroupSetDialogProps = {}

export type CreateGroupSetDialogState = {
    GroupSetGroupSetNameErrorMessage: string;
    GroupSetGroupSetNameText: string;
    isGroupSetGroupSetNameTextValid: boolean;
}

export type CreateGroupSetActionDialogProps = ReactActionDialogBodyProps<CreateGroupSetDialogProps, CreateGroupSetDialogState>;
export function CreateGroupSetDialogBody(props: CreateGroupSetActionDialogProps): JSX.Element {
    const {
        GroupSetGroupSetNameErrorMessage,
        GroupSetGroupSetNameText,
        isGroupSetGroupSetNameTextValid
      } = props.dialogState;
    return <>
         <div style={dialogBodyStyles}>
            <div style={dialogElementStyles}>
            <DialogLabel message={Messages.groupSetName()} labelStyles={labelStyles}/>
            <GroupSetNameField
                GroupSetGroupSetNameErrorMessage={GroupSetGroupSetNameErrorMessage}
                GroupSetGroupSetNameText={GroupSetGroupSetNameText}
                isGroupSetGroupSetNameTextValid={isGroupSetGroupSetNameTextValid}
                doAction={props.doAction}
                updateState={props.updateDialogState}/>
            </div>
         </div>
    </>;
}

type DialogLabelStyleProps = {
    message: string;
    labelStyles: React.CSSProperties;
}

function DialogLabel(props: DialogLabelStyleProps): JSX.Element {
    return <div style={props.labelStyles}><span>{props.message}</span></div>;
}

type GroupSetNameFieldProps = {
    GroupSetGroupSetNameErrorMessage: string;
    GroupSetGroupSetNameText: string;
    isGroupSetGroupSetNameTextValid: boolean;
    doAction: () => void;
    updateState: React.Dispatch<MergeOrUpdateStateAction<CreateGroupSetDialogState>>;
}

function GroupSetNameField(props: GroupSetNameFieldProps): JSX.Element {
    const {
        GroupSetGroupSetNameErrorMessage,
        GroupSetGroupSetNameText,
        isGroupSetGroupSetNameTextValid,
        doAction
      } = props;
    const onTextFieldClear = () => props.updateState({ GroupSetGroupSetNameErrorMessage: undefined, GroupSetGroupSetNameText: '', isGroupSetGroupSetNameTextValid: true });
    const onTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.value;
    const isValid = name.length <= CHARACTER_LIMIT ? true : false;
    props.updateState({
        GroupSetGroupSetNameErrorMessage: isValid ? undefined : characterCounter({ value: name, maximum: CHARACTER_LIMIT }),
        GroupSetGroupSetNameText: name,
        isGroupSetGroupSetNameTextValid: isValid,
    });
    };
    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
        doAction();
    } else if (e.key === 'Escape') {
        onTextFieldClear();
    }
    };
    return <TextFieldWidget
        className={textFieldStyles}
        kind='outline'
        label={''}
        aria-label={Messages.groupSetName()}
        onChange={onTextFieldChange}
        onClear={onTextFieldClear}
        onKeyDown={onKeyDown}
        message={GroupSetGroupSetNameErrorMessage ? GroupSetGroupSetNameErrorMessage : ZERO_WIDTH_SPACE}
        spellCheck={false}
        testId={NAME_GROUP_TEXT_FIELD_TEST_ID}
        valid={isGroupSetGroupSetNameTextValid ? undefined : false}
        value={GroupSetGroupSetNameText}
        style={groupSetNameFieldStyles}
        placeholder={Messages.groupSetNameShadowText()}
  />;
}